export interface Review {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  tags: string[];
  cover: string;
  relatedDramaId: string;
  content: string[];
}

export const reviews: Review[] = [
  {
    id: "r1",
    title: "《出轨的妻子》：当怀疑成为一种习惯，婚姻便不再有安全区",
    excerpt:
      "这部剧最锋利的地方，不是它拍了一场背叛，而是它拍出了怀疑如何一天天长成一座牢笼，把两个人一起关在里面。",
    author: "影评人 · 沈砚",
    date: "2024-09-18",
    tags: ["深度解读", "家庭伦理"],
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20scene%20of%20a%20dark%20apartment%20living%20room%20at%20night%20with%20warm%20amber%20light%20and%20crimson%20shadows%2C%20tense%20emotional%20atmosphere%2C%20film%20still%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-01&orientation=landscape",
    relatedDramaId: "d1",
    content: [
      "《出轨的妻子》并没有把一个出轨的故事讲成猎奇的奇观。它更关心的是：在一段关系里，人是怎么一点点失去信任，又是怎么把这份不安投射到对方身上的。",
      "剧集前八集几乎没有爆发性的冲突，所有的张力都藏在细节里——一句没被回应的问候、一次被敷衍的晚归、一个多看了一眼的手机屏幕。编剧相信，裂缝是从这些瞬间长出来的。",
      "苏念这个角色之所以动人，是因为她既不是完美的受害者，也不是被误解的圣徒。她有自己的沉默、自己的骄傲，也有自己不敢面对的部分。正因为如此，观众没法轻易地站在任何一边，只能和角色一起，被夹在真相与误会之间。",
      "如果说这部剧有什么野心，那就是它想让观众明白：真正被背叛的，往往不只是某一个人，而是两个人共同相信过的那个未来。",
    ],
  },
  {
    id: "r2",
    title: "叙事迷宫里的真相：《她背叛的那一夜》的倒叙艺术",
    excerpt:
      "同一个夜晚，三个人三种版本。电影用倒叙搭建了一座迷宫，而出口并不通向真相，通向的是每个人愿意相信的自己。",
    author: "影视研究 · 陆知微",
    date: "2024-08-30",
    tags: ["叙事分析", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20street%20reflections%20through%20wet%20glass%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20mysterious%20mood%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-02&orientation=landscape",
    relatedDramaId: "d2",
    content: [
      "《她背叛的那一夜》最聪明的地方，是把观众放在了和男主角一样的位置——我们和沈迟一样，只能通过零散的回忆来拼凑那个夜晚。",
      "影片三次回到同一个时间点，每次都换一个视角。第一遍看是背叛，第二遍看是误会，第三遍看才发现，其实所有人都只记得对自己有利的那部分。",
      "这种叙事结构不是为了卖弄技巧，而是为了让观众亲身体验：我们对一段关系的判断，往往取决于我们站在哪个位置，而不是真相本身。",
    ],
  },
  {
    id: "r3",
    title: "裂缝不是一天形成的：《婚姻的裂缝》为什么让人不敢快进",
    excerpt:
      "它拍的不是大事，而是那些被忽略的小事——一顿沉默的晚餐，一句没说完的话。恰恰是这些，最让人窒息。",
    author: "影评人 · 苏迟",
    date: "2024-07-22",
    tags: ["家庭伦理", "人物分析"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20dim%20family%20dining%20room%20with%20empty%20chairs%20and%20soft%20amber%20light%2C%20melancholic%20cinematic%20still%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-03&orientation=landscape",
    relatedDramaId: "d3",
    content: [
      "《婚姻的裂缝》拒绝戏剧化的狗血，它选择了一条更难走的路：用日常的琐碎去呈现一段关系的疏离。",
      "温以宁重新回到职场的每一个镜头，都带着一种小心翼翼的兴奋。观众能清晰地感受到，她找回的不只是工作，还有‘自己’这个名字。",
      "这部剧最大的善意在于，它没有把任何一方塑造成反派。它只是诚实地告诉我们，爱会在忽略中变淡，也能在重新看见对方的那一刻，慢慢回来。",
    ],
  },
  {
    id: "r4",
    title: "沉默的台词：《沉默的裂痕》里没说出口的一切",
    excerpt:
      "一部几乎没有争吵的婚姻电影，却比任何声嘶力竭的对峙都更让人难过。因为最痛的，往往是安静。",
    author: "专栏作者 · 白舟",
    date: "2024-06-15",
    tags: ["文艺", "深度解读"],
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20minimalist%20apartment%20room%20at%20dusk%20with%20warm%20low%20light%20and%20a%20lone%20chair%2C%20muted%20amber%20tones%2C%20art%20film%20still%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-04&orientation=landscape",
    relatedDramaId: "d4",
    content: [
      "在这部电影里，沉默不是没有内容，而是内容太多。白榆和简川之间，每一段空白都写着没说出口的话。",
      "导演对空间的使用极其克制：两人总是被安排在同一画面的两端，中间隔着餐桌、茶几、走廊，仿佛物理距离就是他们心理距离的注脚。",
      "影片结尾那个并肩而坐的背影，是全片唯一一次两人真正靠近。那两分钟里没有一句台词，却让人听见了整部电影最响的声音。",
    ],
  },
  {
    id: "r5",
    title: "如果当初：《回不去的从前》与成年人的选择题",
    excerpt:
      "剧集温柔地问了一个残酷的问题——如果没有做另一个选择，我们现在的日子会更好吗？然后让每个人自己去回答。",
    author: "影评人 · 温故",
    date: "2024-10-02",
    tags: ["都市情感", "人物分析"],
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20nostalgic%20room%20with%20old%20photographs%20on%20a%20wooden%20table%2C%20warm%20afternoon%20amber%20tones%2C%20cinematic%20still%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-05&orientation=landscape",
    relatedDramaId: "d5",
    content: [
      "《回不去的从前》最难得的是，它没有把‘过去’浪漫化。旧爱带来的不是救赎，而是一面镜子，照出的是现在这段关系里被忽略的部分。",
      "三个女性的三条线索彼此映照，构成了关于婚姻三种不同阶段的观察。她们最终都没有找到标准答案，但都学会了为自己的选择负责。",
      "这或许才是成年人最真实的成长：不是不再后悔，而是带着后悔继续往前走。",
    ],
  },
  {
    id: "r6",
    title: "谁才是《第三个人》？一场关于共犯关系的冷静解剖",
    excerpt:
      "电影里每个人都在寻找第三个人，最后却发现，输给的不是某个人，而是婚姻里那个从未被填满的缺口。",
    author: "影视研究 · 黎野",
    date: "2024-05-09",
    tags: ["悬疑", "深度解读"],
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20noir%20interior%20with%20a%20single%20warm%20lamp%20and%20three%20long%20shadows%2C%20deep%20crimson%20and%20amber%20tones%2C%20suspenseful%20cinematic%20still%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-06&orientation=landscape",
    relatedDramaId: "d6",
    content: [
      "很多人看《第三个人》，第一反应是想找出那个‘第三者’是谁。但电影真正想问的，是为什么一段婚姻会需要这样一道出口。",
      "影片中所有人物都带着自己的隐瞒，没有一个是完全无辜的受害者。这种处理让故事不再是非黑即白的道德审判，而更像一场冷静的关系解剖。",
      "当真相被完整拼起，观众会意识到：构成伤害的从来不是某一次事件，而是所有人共同维持的那些沉默。",
    ],
  },
  {
    id: "r7",
    title: "《红色婚戒》：当爱情被写进家族的账本",
    excerpt:
      "一枚婚戒串起两代人的恩怨。它讲述的不只是婚姻，更是人在爱恨之间的选择权。",
    author: "专栏作者 · 何砚",
    date: "2024-04-20",
    tags: ["家族伦理", "人物分析"],
    cover:
      "https://readdy.ai/api/search-image?query=Luxurious%20dim%20mansion%20interior%20with%20rich%20crimson%20and%20gold%20warm%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-07&orientation=landscape",
    relatedDramaId: "d9",
    content: [
      "《红色婚戒》把个人情感放进家族利益的框架里审视，让爱情从一开始就带着沉重的注脚。",
      "余蔓青这个角色的可贵，在于她没有被困在‘受害者’的位置上。她选择主动去弄清楚真相，哪怕真相会伤害到她自己。",
      "剧集对‘选择权’的讨论尤其动人：爱一个人，和被安排去爱一个人，是两件完全不同的事。",
    ],
  },
  {
    id: "r8",
    title: "为自己活一次：《她的秘密》与女性的自我定义",
    excerpt:
      "电影最后揭晓的秘密，不是背叛，而是一个女人终于决定为自己的人生做主。这份勇气让整部片子亮了起来。",
    author: "影评人 · 顾南",
    date: "2024-09-05",
    tags: ["女性成长", "深度解读"],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20office%20at%20golden%20hour%20with%20warm%20amber%20light%20through%20tall%20windows%2C%20cinematic%20and%20hopeful%2C%20no%20text&width=1200&height=800&seq=chu-gui-review-08&orientation=landscape",
    relatedDramaId: "d10",
    content: [
      "《她的秘密》最聪明的地方，是把‘秘密’设置在观众的预期之外。我们跟着丈夫的视角去猜忌、去不安，最后才发现自己猜错了方向。",
      "黎昭昭想要的从来不是离开，而是被允许成为更完整的自己。这个诉求在婚姻的语境里，显得既合理又奢侈。",
      "电影让我们看到，一个女人最大的背叛，或许不是对别人，而是对自己梦想的长期忽略。",
    ],
  },
];